// extracted by mini-css-extract-plugin
export default {"bns3_subscriptionContent":"SubscriptionContent_bns3_subscriptionContent__6ZNUd"};